<template>
	<div class="password">
		<a class="link" @click="resetPassword">Reset password</a>
		<div class="msg" v-text="message"/>
	</div>
</template>

<script>
export default {
	props: {

	},
	data() {
		return {
			message: ""
		}
	},
	computed: {
		user: (t) => t.$store.getters["user/data"]
	},
	methods: {
		async resetPassword() {
			const {data: {message}} = await this.$store.dispatch("user/forgotPassword", {email: this.user.email});
			this.message = message;
		}
	}
};
</script>

<style lang="scss" scoped>
.password {
	font-size: 14px;

	.link {
		display: inline-block;
		margin: 1.2em 0 0.5em;
		text-decoration: underline;

		@include res(mobile) {
			margin: 0;
			margin-bottom: 0.5em;
		}
	}

	.msg {
		font-size: 12px;
		color: $green1;
		line-height: 1.25;
	}
}
</style>
